import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import useSWR from 'swr'

import { Loading } from '@/components/Loading'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { apiFetcher } from '@/data/fetcher'
import { DocumentForm } from '@/forms/DocumentForm'
import { Settings } from '@/interfaces/Settings'

export default function ExpenseEditPage() {
  const { id } = useParams()
  const { t } = useTranslation(undefined, {
    keyPrefix: 'expense',
  })
  const { data: documentData, isLoading: expensesLoading } = useSWR(
    id && `/api/v2/expenses/${id}`,
    apiFetcher,
  )
  const { data: settings, isLoading: settingsLoading } = useSWR<Settings>(
    `/api/v2/settings`,
    apiFetcher,
  )
  const title = `${t('edit.title')} ${id}`

  useSetPageHeader({
    breadcrumbs: [
      {
        href: '/expenses',
        children: t('list.title'),
      },
      {
        href: `/expense/${id}`,
        children: id as string,
      },
      {
        href: `/expense/${id}/edit`,
        children: t('edit.breadcrumb'),
      },
    ],
  })

  return (
    <>
      <title>{title}</title>

      {(expensesLoading || settingsLoading) && (
        <Loading />
      )}

      {documentData && settings && (
        <DocumentForm
          type="expense"
          documentData={documentData}
          settings={settings}
        />
      )}
    </>
  )
}
